export default __webpack_public_path__ + "static/media/blog-noData.c726ace9.webp";